var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgThumbnail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.75 1h4.134l.183.183 1.75 1.75.183.183V9.25h-6.25V1.625zM12 2.25V8h3.75V3.634L14.366 2.25zm-8.375 8.5H3V19h6.25v-6.134l-.183-.183-1.75-1.75-.183-.183h-.259zm.625 7V12h2.366L8 13.384v4.366zm7.125-7h-.625V19H17v-6.134l-.183-.183-1.75-1.75-.183-.183h-.259zm.625 7V12h2.366l1.384 1.384v4.366zM3.625 1H3v8.25h6.25V3.116l-.183-.183-1.75-1.75L7.134 1h-.259zm.625 7V2.25h2.366L8 3.634V8z",
  clipRule: "evenodd"
})));
export default SvgThumbnail;